export class CurrencyUtil {
    constructor(config) {
        this.currencies = {};
        this.defaultConfigKey = "";
        this.set(config);
    }
    getKey(key, skipDefault) {
        if (this.currencies[key]) {
            return key;
        }
        return skipDefault ? "" : this.defaultConfigKey;
    }
    applyFormatting(format, ...args) {
        return format.replace(/{(\d+)}/g, (match, d) => args[d]);
    }
    set(config) {
        this.currencies = {};
        this.defaultConfigKey = "";
        config.forEach(x => {
            this.currencies[x.code] = x;
            x.isDefault && (this.defaultConfigKey = x.code);
        });
    }
    format(options) {
        const { amount, currency } = options;
        if (!amount) {
            return "";
        }
        let config, key = this.getKey(currency.code, currency.skipDefault);
        if (!key) {
            return amount;
        }
        config = Object.assign(Object.assign({}, this.currencies[key]), currency);
        return this.applyFormatting(config.format, amount, config.sign);
    }
}
//# sourceMappingURL=CurrencyUtil.js.map